<template>
  <div>
    <h1 class="mb-4 text-center">List of XP Conditions</h1>
    <div class="flex justify-between items-center">
      <BaseLink
        :link="{ name: 'AddXPCondition' }"
        class="bg-green text-white px-4 py-2 add-btn"
        >Create New XP Condition</BaseLink
      >
      <div class="flex justify-center items-center">
        <BaseButton
          :class="{ 'bg-blue-lighter': listAll }"
          class="inline-block mx-2 px-4 py-2"
          btnStyle="link"
          @click="applyFilter(null)"
        >
          All XP Conditions
        </BaseButton>
        <BaseButton
          :class="{ 'bg-blue-lighter': $route.query.state === 'active' }"
          class="inline-block mx-2 px-4 py-2"
          btnStyle="link"
          @click="applyFilter('active')"
        >
          Active XP Conditions
        </BaseButton>
        <BaseButton
          :class="{ 'bg-blue-lighter': $route.query.state === 'inactive' }"
          class="inline-block mx-2 px-4 py-2"
          btnStyle="link"
          @click="applyFilter('inactive')"
        >
          Inactive XP Conditions
        </BaseButton>
      </div>
    </div>
    <Table ref="table" :endpoint="endpoint" :tableConfig="config" class="mt-8">
      <template #row="{row}">
        <td>{{ row.name }}</td>
        <td>{{ row.component }}</td>
        <td>{{ getCondition(row.condition) }}</td>
        <td>{{ row.xp_points }}</td>
        <td>{{ row.max_count }}</td>
        <td class="flex justify-start items-center">
          <span v-if="isActivating(row.id)" class="text-green">
            {{ getStatusById(row.id).status | capitalize }}

            <ProgressBar
              :progress="getStatusById(row.id).progress"
              class="text-green text-xs"
            />
          </span>
          <button
            v-else
            class="w-full h-8 rounded-none bg:transparent flex justify-start items-center fadeIn"
            :style="`color: ${row.state === 'active' ? '#1ACD62' : '#FF7322'}`"
            @click="
              handleToggleBtnClick(
                row,
                row.state === 'active' ? 'deactivate' : 'activate'
              )
            "
          >
            <i class="material-icons text-3xl mr-1">{{
              row.state === "active" ? "toggle_on" : "toggle_off"
            }}</i>
            <span>
              {{ row.state | capitalize }}
            </span>
          </button>
        </td>
        <td>
          <router-link
            :to="{ name: 'EditXPCondition', params: { id: row.id } }"
            class="w-10 h-8 inline-block hover:bg-grey-light flex justify-center items-center no-underline"
          >
            <i class="material-icons text-xl">edit</i>
          </router-link>
        </td>
        <td class="text-center">
          <button
            class="w-10 h-8 rounded-none bg:transparent flex justify-center items-center"
            @click="deleteCondition(row)"
          >
            <i class="material-icons text-2xl text-red">delete_forever</i>
          </button>
        </td>
      </template>
    </Table>
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"
import xpConditionMixin from "@/mixins/xpConditionMixin"
import BaseLink from "@/components/Base/BaseLink"
import BaseButton from "@/components/Base/BaseButton"
import Table from "@/components/DataTable/Table"
import ProgressBar from "@/components/shared/ProgressBar"

export default {
  components: { BaseLink, Table, BaseButton, ProgressBar },
  mixins: [xpConditionMixin],
  data() {
    return {
      config: [
        { header: { textContent: "Name", sortingParam: "name" } },
        "Component",
        "Condition",
        "Points",
        "Max Redemption",
        { header: "Status", sortingParam: "state" },
        "Edit",
        "Delete",
      ],
    }
  },
  computed: {
    listAll() {
      return !Reflect.has(this.$route.query, "state")
    },
    endpoint: () => `${siteConfig.siteURL}admin/xp_points/conditions`,
  },
  methods: {
    getCondition(condition) {
      return Object.values(condition)
        .join(" ")
        .trim()
    },
    async handleToggleBtnClick(item, actionType) {
      const value = await this.confirmToggle(item.name, actionType)
      if (!value) return
      this.updateActiveStatus({
        name: item.name,
        id: item.id,
        actionType,
      }).then(() => {
        this.$refs.table.getItems()
      })
    },
    applyFilter(filter = null) {
      this.$refs.table.updateRoute({ key: "state", value: filter })
    },
    hasRouteQuery(param) {
      return this.$route.query && Reflect.has(this.$route.query, param)
    },
  },
}
</script>

<style scoped>
.add-btn {
  color: #fff;
}
</style>
